import FormattedMessage from 'I18n/components/FormattedMessage';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { StyledTableCell } from '../table/StyledTableCell';
import { useMilestoneTableSize } from '../table/MilestoneTableSizeContext';
import { RowHoverContainer } from './styledComponents/RowHoverContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddMilestoneRow = ({
  onAddMilestone
}) => {
  const size = useMilestoneTableSize();
  const content = /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    children: [/*#__PURE__*/_jsx(Checkbox, {
      checked: false,
      disabled: true,
      size: "sm",
      marginBlockStart: "100"
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(AddIcon, {
        color: "icon-core-disabled",
        size: "100"
      }), /*#__PURE__*/_jsx(Text, {
        use: "disabled",
        typography: "body-100",
        truncate: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.milestones.addMilestone"
        })
      })]
    })]
  });
  if (size === 'small') {
    return /*#__PURE__*/_jsx(RowHoverContainer, {
      onClick: onAddMilestone,
      children: /*#__PURE__*/_jsx(StyledTableCell, {
        colSpan: 3,
        children: content
      })
    });
  }
  return /*#__PURE__*/_jsxs(RowHoverContainer, {
    onClick: onAddMilestone,
    children: [/*#__PURE__*/_jsx(StyledTableCell, {
      children: content
    }), /*#__PURE__*/_jsx(StyledTableCell, {}), /*#__PURE__*/_jsx(StyledTableCell, {}), /*#__PURE__*/_jsx(StyledTableCell, {})]
  });
};